import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import InputForm from "../../../../components/input/input-form";
import AgGridUtils from "../../../../utils/aggrid-utils";
import { Modal } from "../../../../components/modal/modal";
import Button from "../../../../components/button/button";
import aggridUtils from "../../../../utils/aggrid-utils.js";

const ModalRemoveDevice = ({ show, onClose, onConfirm, existingDevices = [] }) => {
    const [selected, setSelected] = useState([]);
    const gridRef = useRef(null);

    useEffect(() => {
        if(show) setSelected([]);
    }, [show]);

    const columnDefs = [
        { headerName: "Dispositivos", field: "text", flex: 1 }
    ];
        
    const CustomFloatingFilter = (props) => {
        const [filterName, setFilterName] = useState("");

        const handleChange = (e) => {
            const value = e.target.value;
            setFilterName(value);

            props.parentFilterInstance((inst) => {
                inst.onFloatingFilterChanged("contains", value);
            });
        };
        return (
            <div className="bg-white rounded-md">
                <InputForm 
                    type="text"
                    value={filterName}
                    onChange={handleChange}
                />
            </div>
        );
    };

    const defaultColDef = {
        sortable:true,
        resizable: true,
        floatingFilter: true,
        filter: "agTextColumnFilter",
        filterParams: aggridUtils.filterParams,
        floatingFilterComponent: CustomFloatingFilter,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        suppressFloatingFilterButton: true,
    };

    const handleSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelected(selectedRows);
    };

    const handleConfirm = () => {
        onConfirm(selected);
        onClose();
    }

    return (
        <Modal
            open={show}
            setOpen={(value) => { if (!value) onClose();}}
            title="Remover dispositivo"
            className="w-full max-w-2xl"
        >
            <Modal.Body>
                <div className="aggrid-row-pointer" style={{ height: "calc(60vh)" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={existingDevices}
                        columnDefs={columnDefs}
                        rowSelection={{
                            mode: "multiRow",
                            enableSelectionWithoutKeys: true,
                            enableClickSelection: true,
                        }}
                        animateRows={false}
                        suppressCellFocus={true}
                        suppressHeaderFocus={true}
                        defaultColDef={defaultColDef}
                        onSelectionChanged={handleSelectionChanged}
                        rowHeight={32}
                        overlayNoRowsTemplate="Nenhum dispositivo vinculado"
                        gridOptions={{ localeText: AgGridUtils.localization() }}
                        theme={AgGridUtils.generalTheme()}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="flex w-full justify-end gap-2">
                    <Button target="danger" onClick={handleConfirm} actionFeedbackType="delete">Remover</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalRemoveDevice;